var _g, _g2, _polygon, _polygon2, _path, _circle, _path2, _polygon3, _path3, _path4, _path5, _path6, _path7, _polygon4, _rect, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _polygon5, _polygon6, _g3, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _rect2, _rect3, _path47, _path48, _path49, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDc11(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 470.78 433.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete",
    "data-name": "Background Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.42,
    y: 286.44,
    width: 69.22,
    height: 55.34,
    transform: "translate(-70.27 -9.62) rotate(-10.6)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,280.56l-.33.08-1,.19-3.69.72-13.93,2.67L26,293.52l.19-.28c3,16.19,6.52,34.75,10.21,54.39h0l-.32-.22,68.05-12.68-.18.26c-3-16.38-5.51-29.95-7.26-39.46-.86-4.75-1.54-8.48-2-11-.22-1.27-.4-2.24-.52-2.92s-.16-1-.16-1,.07.32.2,1,.32,1.63.57,2.87c.49,2.55,1.2,6.26,2.11,11,1.81,9.53,4.39,23.14,7.51,39.56l0,.21-.22,0L36.14,348l-.26.05-.05-.27h0c-3.66-19.64-7.13-38.21-10.15-54.4l0-.24.23,0L75.16,284l13.89-2.53,3.67-.66.93-.16Z",
    transform: "translate(-13.61 -26.94)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.81,
    y: 289.93,
    width: 64.35,
    height: 48.37,
    transform: "translate(-70.27 -9.63) rotate(-10.6)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "24.19 316.88 40.76 283.19 57.9 299.12 65.34 287.5 87.45 305.05 24.19 316.88",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.19,302.87a5.07,5.07,0,1,1-5.92-4.05A5.07,5.07,0,0,1,73.19,302.87Z",
    transform: "translate(-13.61 -26.94)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.95,
    y: 89.37,
    width: 195.56,
    height: 144.79,
    transform: "translate(32.47 351.76) rotate(-79.74)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.57,270.89s.05-.32.15-.92l.48-2.7c.42-2.39,1.05-5.9,1.86-10.48,1.65-9.16,4.05-22.54,7.09-39.48l25-138.9.2.28L195.9,52.92h0l.31-.21c-13,71.78-25.07,138.28-34.88,192.43l-.18-.26,103.53,18.86L293.41,269l7.56,1.4c1.71.31,2.6.49,2.6.49l-2.56-.44-7.53-1.34L264.75,264l-103.7-18.66-.22,0,0-.21c9.79-54.16,21.82-120.66,34.8-192.45l0-.27.27,0h0L338.45,78.21l.24.05,0,.23c-10.37,57-19.13,105.13-25.29,139l-7.2,39.4c-.84,4.55-1.48,8-1.92,10.42-.22,1.17-.38,2.06-.5,2.67S303.57,270.89,303.57,270.89Z",
    transform: "translate(-13.61 -26.94)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.65,
    y: 74.08,
    width: 53.56,
    height: 61.48,
    transform: "translate(75.11 288.91) rotate(-79.74)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.23,
    y: 72.92,
    width: 6.99,
    height: 39.36,
    transform: "translate(139.14 341.14) rotate(-79.74)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.39,
    y: 93.83,
    width: 6.99,
    height: 112.34,
    transform: "translate(45.81 344.2) rotate(-79.74)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.2,
    y: 105.94,
    width: 6.99,
    height: 112.34,
    transform: "translate(32.1 352) rotate(-79.74)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.01,
    y: 118.04,
    width: 6.99,
    height: 112.34,
    transform: "translate(18.39 359.79) rotate(-79.74)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.82,
    y: 130.15,
    width: 6.99,
    height: 112.34,
    transform: "translate(4.67 367.58) rotate(-79.74)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.63,
    y: 142.25,
    width: 6.99,
    height: 112.34,
    transform: "translate(-9.04 375.38) rotate(-79.74)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.12,
    y: 183.75,
    width: 6.99,
    height: 112.34,
    transform: "translate(-56.04 402.09) rotate(-79.74)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.51,
    y: 175.18,
    width: 6.99,
    height: 61.67,
    transform: "translate(-38.8 354.93) rotate(-79.74)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.21,
    y: 84.05,
    width: 6.99,
    height: 39.36,
    transform: "translate(126.54 348.31) rotate(-79.74)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.2,
    y: 95.18,
    width: 6.99,
    height: 39.36,
    transform: "translate(113.93 355.47) rotate(-79.74)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.76,
    y: 112.51,
    width: 6.99,
    height: 24.27,
    transform: "translate(96.54 354.23) rotate(-79.74)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.04,
    y: 132.59,
    width: 59.26,
    height: 47.38,
    transform: "translate(-44.03 98.54) rotate(-18.47)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.08,
    y: 135.59,
    width: 55.1,
    height: 41.41,
    transform: "translate(-44.03 98.52) rotate(-18.47)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.45 157.73 347.55 127.22 363.95 138.72 368.9 127.99 389.71 140.28 337.45 157.73",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.26,145.79a4.34,4.34,0,1,1-5.49-2.74A4.33,4.33,0,0,1,376.26,145.79Z",
    transform: "translate(-13.61 -26.94)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.11,
    y: 71.11,
    width: 71.59,
    height: 89.55,
    transform: "translate(219.96 488.56) rotate(-78.92)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.72,89.37l-.43-.07-1.24-.22-4.78-.91-18-3.46L392.8,72.4l.28-.19c-4.09,20.91-8.77,44.88-13.73,70.25h0l-.21-.32L467,159.41l-.26.17c4.19-21.14,7.66-38.67,10.09-50.92,1.23-6.13,2.19-10.94,2.85-14.23.33-1.64.58-2.89.76-3.76s.28-1.3.28-1.3-.07.43-.22,1.27-.4,2.1-.71,3.72c-.63,3.28-1.55,8.08-2.72,14.2-2.38,12.3-5.79,29.89-9.89,51.11l0,.22-.22,0L379,142.68l-.27-.05.05-.26h0c5-25.36,9.69-49.33,13.79-70.24l.05-.24.23.05L456.47,84.5l17.92,3.58,4.72,1,1.21.25Z",
    transform: "translate(-13.61 -26.94)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.56,
    y: 74.24,
    width: 62.58,
    height: 83.25,
    transform: "translate(219.92 488.49) rotate(-78.92)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.37 111.65 405.38 79.06 418.38 106.41 432.87 95.99 451.07 127.65 369.37 111.65",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.09,106.26a6.56,6.56,0,1,1-5.18-7.69A6.55,6.55,0,0,1,445.09,106.26Z",
    transform: "translate(-13.61 -26.94)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41.13 6.27 45.68 59.25 66.22 64.82 106.08 60.19 100.47 0.55 41.13 6.27",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.55,81.43l-6.26,4.76a22.73,22.73,0,0,0,8.17,4.54,32.74,32.74,0,0,0,12.37,1S70.34,90.12,65.55,81.43Z",
    transform: "translate(-13.61 -26.94)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.28,47c0,.09-10.08,1.15-22.53,2.36s-22.57,2.11-22.58,2S74.25,50.18,86.71,49,109.27,46.87,109.28,47Z",
    transform: "translate(-13.61 -26.94)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.87,55.12c0,.1-10.08,1.16-22.53,2.37s-22.57,2.1-22.58,2,10.08-1.16,22.54-2.37S109.86,55,109.87,55.12Z",
    transform: "translate(-13.61 -26.94)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.82,62.31c0,.1-10.08,1.16-22.53,2.36s-22.56,2.11-22.57,2,10.07-1.15,22.53-2.36S110.81,62.21,110.82,62.31Z",
    transform: "translate(-13.61 -26.94)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.45,69.26c0,.1-10.08,1.15-22.54,2.36s-22.56,2.11-22.57,2,10.08-1.16,22.54-2.36S111.44,69.16,111.45,69.26Z",
    transform: "translate(-13.61 -26.94)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M484.39,459.9c0,.14-105.4.26-235.38.26s-235.4-.12-235.4-.26,105.37-.27,235.4-.27S484.39,459.75,484.39,459.9Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Thesis"
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "28.33 98.41 70.49 339.83 248.27 311.92 256.51 292.01 208.41 68.78 41.77 78.72 28.33 98.41",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "70.49 339.83 83.12 320.48 40.96 79.05 28.33 98.41 70.49 339.83",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "40.96 79.05 83.12 320.48 256.51 292.01 212.71 54.56 40.96 79.05",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.57,106,226.28,81.28l.21,0,0,.21C238.78,147.81,254,230,270.38,318.9l.05.27-.27,0-2.86.47-170.53,28-.24,0,0-.23C71.73,204.86,54.94,108.12,54.57,106c.37,2.13,17.36,98.83,42.4,241.38l-.28-.19,170.52-28,2.86-.47-.22.31c-16.38-88.91-31.52-171.1-43.75-237.46l.24.17Z",
    transform: "translate(-13.61 -26.94)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 164.29,
    cy: 216.42,
    r: 29.55,
    transform: "translate(-85.49 323.84) rotate(-82.43)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M150.74,224.18l-1.34-8.5L178.87,211l1.26,8s-1.8,6.87-13.72,8.75S150.74,224.18,150.74,224.18Z",
    transform: "translate(-13.61 -26.94)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "131.14 188.78 152.17 192.52 170.41 182.25 149.35 178.93 131.14 188.78",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M204.68,140.06l-104.5,16.51a2.36,2.36,0,0,1-2.69-1.95l-.35-2.24a2.35,2.35,0,0,1,2-2.69l104.5-16.51a2.35,2.35,0,0,1,2.69,1.95l.35,2.24A2.35,2.35,0,0,1,204.68,140.06Z",
    transform: "translate(-13.61 -26.94)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M188.14,157.45l-66.27,10.46a2.35,2.35,0,0,1-2.69-1.95l-.35-2.24a2.34,2.34,0,0,1,2-2.68l66.27-10.47a2.35,2.35,0,0,1,2.69,2l.35,2.24A2.36,2.36,0,0,1,188.14,157.45Z",
    transform: "translate(-13.61 -26.94)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M212,305.57,145.73,316a2.34,2.34,0,0,1-2.68-2l-.35-2.24a2.33,2.33,0,0,1,2-2.68l66.27-10.47a2.33,2.33,0,0,1,2.68,1.95l.36,2.24A2.34,2.34,0,0,1,212,305.57Z",
    transform: "translate(-13.61 -26.94)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M261.19,325.66l-.84.16-2.48.43-9.59,1.6-35.61,5.84L92.37,353.24l-.26.05,0-.26c-1.69-9.55-3.46-19.55-5.26-29.74C77.18,268.54,68.46,219,62.15,183.11l-7.41-42.49c-.87-5-1.54-8.91-2-11.56-.22-1.31-.39-2.32-.51-3s-.15-1-.15-1,.08.35.21,1,.31,1.69.55,3c.48,2.65,1.18,6.54,2.09,11.54,1.79,10,4.38,24.54,7.58,42.46,6.35,35.88,15.13,85.42,24.82,140.16,1.8,10.18,3.56,20.19,5.25,29.74l-.31-.22,120.34-19.38,35.63-5.68,9.61-1.51,2.49-.37C260.9,325.69,261.19,325.66,261.19,325.66Z",
    transform: "translate(-13.61 -26.94)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M248,334.74l-.79.16-2.34.41-9.06,1.54-33.68,5.62L87.83,361.39l-.26,0,0-.26c-2.1-11.5-4.28-23.47-6.51-35.71-9.79-54-18.65-102.84-25.07-138.22-3.18-17.68-5.76-32-7.54-41.9-.87-4.94-1.56-8.78-2-11.39-.22-1.3-.4-2.29-.51-3s-.16-1-.16-1,.08.34.21,1,.32,1.66.56,3c.49,2.61,1.21,6.44,2.12,11.37,1.83,9.9,4.46,24.2,7.71,41.87,6.46,35.38,15.37,84.23,25.23,138.2,2.22,12.23,4.4,24.2,6.49,35.71l-.3-.21L202,342.13l33.71-5.47,9.07-1.45,2.35-.36Z",
    transform: "translate(-13.61 -26.94)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "45.15 181.29 41.25 186.81 50.73 243.7 56.38 245.62 45.15 181.29",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 64.16,
    y: 205.38,
    width: 27.48,
    height: 65.3,
    transform: "translate(-53.39 -10) rotate(-9.9)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M98.73,269.78l-1.76.31a1.84,1.84,0,0,1-2.14-1.5L83.45,203.43a1.85,1.85,0,0,1,1.5-2.14l1.76-.3a1.84,1.84,0,0,1,2.14,1.5l11.38,65.15A1.84,1.84,0,0,1,98.73,269.78Z",
    transform: "translate(-13.61 -26.94)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M80,224.6l-17.57,10a11.34,11.34,0,0,0-10-3.5,11.41,11.41,0,1,0,12.16,15.7l19.83,3.16a1.31,1.31,0,0,0,1.5-1.53l-4-22.89A1.31,1.31,0,0,0,80,224.6Z",
    transform: "translate(-13.61 -26.94)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M94.68,267.75a5.11,5.11,0,0,1-.14-.64c-.09-.48-.2-1.09-.35-1.84-.3-1.67-.72-4-1.24-6.8-1-5.79-2.44-13.69-4-22.42s-2.89-16.65-3.89-22.46c-.47-2.82-.85-5.13-1.12-6.81-.12-.76-.21-1.38-.28-1.86a2.64,2.64,0,0,1-.06-.65,4.14,4.14,0,0,1,.16.63c.1.48.23,1.09.38,1.84.32,1.67.76,4,1.29,6.79,1.07,5.73,2.5,13.66,4,22.42s2.9,16.7,3.84,22.46c.48,2.88.84,5.21,1.08,6.82.11.81.21,1.43.25,1.87A2.66,2.66,0,0,1,94.68,267.75Z",
    transform: "translate(-13.61 -26.94)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M69.46,272.78a3.2,3.2,0,0,1-.15-.65c-.09-.47-.2-1.08-.34-1.84-.31-1.67-.73-4-1.25-6.79-1-5.8-2.44-13.7-4-22.43s-2.88-16.65-3.89-22.45c-.46-2.83-.85-5.14-1.12-6.81-.12-.77-.21-1.38-.28-1.86a2.71,2.71,0,0,1-.06-.66,3.68,3.68,0,0,1,.17.64c.09.48.22,1.09.37,1.84.32,1.67.76,4,1.29,6.78,1.07,5.74,2.5,13.66,4,22.43s2.9,16.7,3.85,22.45c.47,2.88.84,5.21,1.07,6.83.12.81.21,1.43.25,1.86A4.64,4.64,0,0,1,69.46,272.78Z",
    transform: "translate(-13.61 -26.94)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M184,209.2a10.26,10.26,0,0,1-1.38.89l-3.86,2.27c-3.28,1.9-7.83,4.49-12.87,7.33l-.09.05-.09,0-.21,0c-5.75-1-10.94-2-14.7-2.69l-4.45-.87a9.33,9.33,0,0,1-1.62-.4,12.11,12.11,0,0,1,1.66.19l4.47.71c3.78.62,9,1.52,14.74,2.54l.2,0-.17,0c5-2.83,9.62-5.37,12.94-7.19l3.95-2.12A8.63,8.63,0,0,1,184,209.2Z",
    transform: "translate(-13.61 -26.94)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Books"
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M284.45,370.54H199.18a17.65,17.65,0,0,1-17.64-17.65v-9.45a17.65,17.65,0,0,1,17.64-17.65h85.27Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#ff725e"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M442,333.22H262.15v-7.43H442a2.93,2.93,0,0,1,2.93,2.93v1.57A2.93,2.93,0,0,1,442,333.22Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#ff725e"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M442,370.54H262.15v-7.43H442a2.93,2.93,0,0,1,2.93,2.93v1.57A2.93,2.93,0,0,1,442,370.54Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#ff725e"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M439.46,363.11H282.55a14.94,14.94,0,0,1-14.94-14.94h0a14.94,14.94,0,0,1,14.94-14.95H439.46A37,37,0,0,0,439.46,363.11Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M267.61,370.54H199.53a18,18,0,0,1-18-18v-8.89a17.86,17.86,0,0,1,17.86-17.86h69.91C253.11,335.61,254.32,359.11,267.61,370.54Z",
    transform: "translate(-13.61 -26.94)",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M420.4,349.55c0,.15-32.21.27-71.93.27s-71.93-.12-71.93-.27,32.2-.27,71.93-.27S420.4,349.4,420.4,349.55Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#263238"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M435.2,356.2c0,.14-32.21.26-71.93.26s-71.93-.12-71.93-.26,32.2-.27,71.93-.27S435.2,356.05,435.2,356.2Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#263238"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M430.84,340.13c0,.15-32.21.27-71.93.27s-71.94-.12-71.94-.27,32.2-.27,71.94-.27S430.84,340,430.84,340.13Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#263238"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M259.73,367.4c0,.15-15.08.27-33.67.27s-33.67-.12-33.67-.27,15.07-.27,33.67-.27S259.73,367.25,259.73,367.4Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#263238"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M259.73,329.51c0,.15-15.08.27-33.67.27s-33.67-.12-33.67-.27,15.07-.27,33.67-.27S259.73,329.36,259.73,329.51Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#263238"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M276.42,459.56H161.54a17.64,17.64,0,0,1-17.64-17.64V419.59a17.65,17.65,0,0,1,17.64-17.65H276.42Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#ff725e"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M480.15,411.51H247.72v-9.57H480.15a2.93,2.93,0,0,1,2.93,2.93v3.71A2.93,2.93,0,0,1,480.15,411.51Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#ff725e"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M480.15,459.56H247.72V450H480.15a2.93,2.93,0,0,1,2.93,2.93v3.7A2.93,2.93,0,0,1,480.15,459.56Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#ff725e"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M476.06,450H274a19.25,19.25,0,0,1-19.24-19.25h0A19.24,19.24,0,0,1,274,411.51H476.06A47.59,47.59,0,0,0,476.06,450Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M254.74,459.56H161.32a17.42,17.42,0,0,1-17.42-17.42V420a18,18,0,0,1,18-18h95C236.07,414.58,237.63,444.85,254.74,459.56Z",
    transform: "translate(-13.61 -26.94)",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M451.51,432.54c0,.15-41.48.27-92.63.27s-92.64-.12-92.64-.27,41.47-.27,92.64-.27S451.51,432.39,451.51,432.54Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#263238"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M470.58,441.09c0,.15-41.48.27-92.64.27s-92.64-.12-92.64-.27,41.47-.26,92.64-.26S470.58,441,470.58,441.09Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#263238"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M465,424.6c0,.15-41.47.27-92.63.27s-92.64-.12-92.64-.27,41.47-.27,92.64-.27S465,424.45,465,424.6Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#263238"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M244.59,455.52c0,.15-19.41.27-43.36.27s-43.36-.12-43.36-.27,19.41-.26,43.36-.26S244.59,455.38,244.59,455.52Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#263238"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M244.59,406.73c0,.14-19.41.26-43.36.26s-43.36-.12-43.36-.26,19.41-.27,43.36-.27S244.59,406.58,244.59,406.73Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#263238"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M310.84,402.15H216.18a13,13,0,0,1-13-13v-7a13,13,0,0,1,13-13h94.66Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#455a64"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M475.68,376.93H287.52v-7.77H475.68a3.06,3.06,0,0,1,3.06,3.07v1.64A3.06,3.06,0,0,1,475.68,376.93Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#455a64"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M475.68,402.15H287.52v-7.77H475.68a3.06,3.06,0,0,1,3.06,3.07v1.64A3.06,3.06,0,0,1,475.68,402.15Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#455a64"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M473,394.38H302a8.72,8.72,0,0,1-8.73-8.72h0a8.73,8.73,0,0,1,8.73-8.73H473Q466.44,385.66,473,394.38Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M293.22,402.15h-77a13.09,13.09,0,0,1-13.09-13.1v-6.52a13.36,13.36,0,0,1,13.36-13.37H295C278.05,376.4,279.32,393.73,293.22,402.15Z",
    transform: "translate(-13.61 -26.94)",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M453.09,384.28c0,.15-33.7.27-75.26.27s-75.26-.12-75.26-.27,33.69-.27,75.26-.27S453.09,384.14,453.09,384.28Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#263238"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M468.58,389c0,.15-33.69.27-75.26.27s-75.26-.12-75.26-.27,33.69-.27,75.26-.27S468.58,388.83,468.58,389Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#263238"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M285,398.87c0,.15-15.77.27-35.23.27s-35.23-.12-35.23-.27,15.77-.27,35.23-.27S285,398.72,285,398.87Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#263238"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M285,373.05c0,.15-15.77.27-35.23.27s-35.23-.12-35.23-.27,15.77-.27,35.23-.27S285,372.9,285,373.05Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#263238"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M476.5,369.16c0,.15-57.87.27-129.23.27S218,369.31,218,369.16s57.85-.27,129.24-.27S476.5,369,476.5,369.16Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#263238"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "359.12 312.7 359.12 330.62 365.33 326.64 372.25 330.62 372.25 312.7 359.12 312.7",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Pencil"
  }, _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "422.23 134.83 390.96 160.88 343.4 254.84 373.05 268.24 419.31 176.09 422.23 134.83",
    fill: "#ff725e"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M432.92,203a2.42,2.42,0,0,1-3-2.42,7.24,7.24,0,0,1-12.72-5.13,8.44,8.44,0,0,1-12.43-7.86l31-25.85Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#fff"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M423.26,172.25s.48,7.78,11.38,6.42l1.2-16.9Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M417.24,195.48l-45.85,92.29-14.38-6,47.56-94,.24-.2a8.15,8.15,0,0,0,.64,3.66,8.87,8.87,0,0,0,3.08,3.76,8.32,8.32,0,0,0,5.69,1.39A8.69,8.69,0,0,0,417.24,195.48Z",
    transform: "translate(-13.61 -26.94)",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430,200.61l-47.1,92.85,3.8,1.72L432.92,203a2.57,2.57,0,0,1-2.93-1.82A2.91,2.91,0,0,1,430,200.61Z",
    transform: "translate(-13.61 -26.94)",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M417,186.52a.67.67,0,0,0-.16.41.88.88,0,0,0,.8.87,3.33,3.33,0,0,0,2-.56,2.11,2.11,0,0,0,.85-.94,1.39,1.39,0,0,0-.09-1.34,1.9,1.9,0,0,0-1.36-.69,6,6,0,0,0-1.73.1,9.51,9.51,0,0,0-3.57,1.39,2.38,2.38,0,0,0-1.1,1.63,2.13,2.13,0,0,0,.87,1.81,5.68,5.68,0,0,0,4.38.54A8.09,8.09,0,0,0,424,184a2.13,2.13,0,0,0-.47-1.8,3.84,3.84,0,0,0-1.53-1,11.11,11.11,0,0,0-3.3-.66,12.24,12.24,0,0,0-4.82.72c-.54.2-.95.39-1.23.52s-.42.2-.42.2a8.93,8.93,0,0,1,1.62-.81,12.13,12.13,0,0,1,4.85-.79,11.11,11.11,0,0,1,3.36.64,4.12,4.12,0,0,1,1.62,1.05,2.32,2.32,0,0,1,.52,2,8.23,8.23,0,0,1-6.27,5.92,7.93,7.93,0,0,1-2.37.17,4.16,4.16,0,0,1-2.19-.76,2.32,2.32,0,0,1-1-2,2.58,2.58,0,0,1,1.19-1.77,9.31,9.31,0,0,1,3.67-1.41,6,6,0,0,1,1.79-.09,2,2,0,0,1,1.46.77,1.56,1.56,0,0,1,.09,1.49,2.25,2.25,0,0,1-.91,1,3.46,3.46,0,0,1-2.05.54,1,1,0,0,1-.84-1C416.83,186.6,417,186.51,417,186.52Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#fff"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M433.78,186s-.46-.07-1.28,0a8.92,8.92,0,0,0-3.36.9,22.78,22.78,0,0,0-4.32,2.88,19.41,19.41,0,0,1-5.44,3.38,11,11,0,0,1-6.36.24,10.72,10.72,0,0,1-4.57-2.52A10.59,10.59,0,0,1,406.3,188a7.26,7.26,0,0,1-.52-1.18,1.3,1.3,0,0,1,.15.29c.09.2.24.49.45.85a11,11,0,0,0,2.18,2.71,10.68,10.68,0,0,0,4.51,2.44,11,11,0,0,0,6.24-.26,19.94,19.94,0,0,0,5.39-3.32,21.34,21.34,0,0,1,4.37-2.86,8.52,8.52,0,0,1,3.42-.85A5.12,5.12,0,0,1,433.78,186Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#fff"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M433.6,195.37a3.43,3.43,0,0,0-2.15-1,19.05,19.05,0,0,0-5.83.86,32.43,32.43,0,0,0-5.56,2.06c-.69.33-1.23.62-1.61.81a3.44,3.44,0,0,1-.59.3,4.67,4.67,0,0,1,.55-.37c.36-.22.9-.54,1.58-.88a28.31,28.31,0,0,1,5.57-2.14,27.83,27.83,0,0,1,3.22-.68,9.65,9.65,0,0,1,2.69-.11,3.39,3.39,0,0,1,1.68.68A2.26,2.26,0,0,1,433.6,195.37Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#fff"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M420.62,202a6.2,6.2,0,0,1,1-.84,7.47,7.47,0,0,1,3-1.33,3.73,3.73,0,0,1,3.11.77,2.76,2.76,0,0,1,.63.77.75.75,0,0,1,.12.35,4,4,0,0,0-.85-1,3.7,3.7,0,0,0-3-.67,8.19,8.19,0,0,0-2.92,1.24A11.3,11.3,0,0,1,420.62,202Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#fff"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M434.6,180.35a.83.83,0,0,1-.15.13c-.1.07-.25.18-.46.31a2.45,2.45,0,0,1-.81.37,2.55,2.55,0,0,1-1.18-.08,28.37,28.37,0,0,1-2.87-1,22.3,22.3,0,0,0-3.56-.89,43.61,43.61,0,0,0-6.69-.45h-2a3.71,3.71,0,0,1-.75,0l.75-.06,2-.07a37.66,37.66,0,0,1,6.72.39,19.91,19.91,0,0,1,3.6.92c1.08.39,2,.82,2.84,1a2.18,2.18,0,0,0,1.91-.21A7.48,7.48,0,0,1,434.6,180.35Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Graduation_Cap",
    "data-name": "Graduation Cap"
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M467.74,265.27v81.91a.65.65,0,0,0,1.29,0V265.27a.65.65,0,0,0-1.29,0Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#ff725e"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M473,329.13a4.62,4.62,0,1,1-4.62-4.62A4.62,4.62,0,0,1,473,329.13Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#ff725e"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M467.1,331.52s-3.37,3.37-4.38,13.24-1.23,14.8-1.23,14.8l9.08.56v-7.06c0,.33,1.8,5.27,1.8,5.27l7.18-2.36S477,329.73,467.1,331.52Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#ff725e"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 252.06,
    y: 245.03,
    width: 154.2,
    height: 55.6,
    fill: "#263238"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 196.67,
    y: 235.46,
    width: 263.75,
    height: 9.57,
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M265.67,311.8s46.84-16.81,77.1-23,77.1-4.14,77.1-4.14V272H265.67Z",
    transform: "translate(-13.61 -26.94)",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.67,
    y: 235.46,
    width: 95.4,
    height: 9.57,
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M472.12,272c0,.15-58.65.27-131,.27s-131-.12-131-.27,58.64-.26,131-.26S472.12,271.83,472.12,272Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#455a64"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M305.53,272.05a44,44,0,0,1,0-9.73,22.53,22.53,0,0,1,.26,4.87A23.18,23.18,0,0,1,305.53,272.05Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#455a64"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M327.52,327.57c-.14,0-.26-10.85-.26-24.23s.12-24.22.26-24.22.27,10.84.27,24.22S327.67,327.57,327.52,327.57Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#455a64"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.45,395.84l17.73-7.16,13.54-35.37,18.05,9.3s-1.74,3.49-5.48,12.14c-1.44,3.34-6.21,12.64-8.15,17.17a23.86,23.86,0,0,1-21.27,14.45l-16.64.43Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.64,389,93,386.18a3,3,0,0,0-1.73-.48l-8.48.25a5.33,5.33,0,0,0-3.93,2.38l-3.09,5.25s-2.07,3.6-1.81,4.47a1.55,1.55,0,0,0,1.79,1.05s.3,1.66.85,2a2.64,2.64,0,0,0,2.07.13,1.73,1.73,0,0,0,1.67,1,2.57,2.57,0,0,0,.44-.08c1-.31,1.46-2.26,1.46-2.26l4.3-.79s6.18,4.13,8.36,6.83,7.88.64,7.88.64l2.13-10.2Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.39,390.21a7,7,0,0,1-1.86.31c-1.17.13-2.82.18-4.69.42l.2-.15a17,17,0,0,1-1.1,2,22.82,22.82,0,0,1-4.08,4.83,7.83,7.83,0,0,1-2.13,1.52c0-.07.74-.67,1.87-1.8a28.14,28.14,0,0,0,3.89-4.83c.41-.67.78-1.33,1.09-2l.06-.13.14,0c1.91-.21,3.56-.19,4.73-.23A8.28,8.28,0,0,1,89.39,390.21Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.58,394.26a4.22,4.22,0,0,1-1.6.42,12.19,12.19,0,0,1-4.15-.14l.31-.17a15,15,0,0,1-.63,1.53,13.08,13.08,0,0,1-3.18,4.2,5.39,5.39,0,0,1-1.83,1.19c0-.07.63-.55,1.57-1.47a15.05,15.05,0,0,0,3-4.15,13.89,13.89,0,0,0,.61-1.47l.08-.22.22,0A20.84,20.84,0,0,0,89.58,394.26Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.36,396.35l-7.57-3.52a8.13,8.13,0,0,0-3.3-1A8,8,0,0,0,86,393q-2,1.05-4.07,2.11a.92.92,0,0,0-.54.48c-.11.31.12.63.35.86a6,6,0,0,0,7.88.32,16.19,16.19,0,0,0,2.55,5,5.54,5.54,0,0,0,5,2.13",
    transform: "translate(-13.61 -26.94)",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.15,404a.63.63,0,0,1-.2.06,2.75,2.75,0,0,1-.62.08,4.85,4.85,0,0,1-2.28-.56,7.14,7.14,0,0,1-2.68-2.44,19.91,19.91,0,0,1-2-4.22l.37.09a6,6,0,0,1-4.4,1.38,6.27,6.27,0,0,1-2.46-.69,5.71,5.71,0,0,1-1.09-.75,3.33,3.33,0,0,1-.49-.5,1.07,1.07,0,0,1-.22-.83.94.94,0,0,1,.46-.56c.18-.11.33-.18.49-.27l.94-.49,1.85-.95a16.77,16.77,0,0,1,3.65-1.59,5.6,5.6,0,0,1,3.59.55c1,.46,2,.92,2.8,1.33l4,2a10.92,10.92,0,0,1,1.45.79,9.92,9.92,0,0,1-1.54-.6l-4.1-1.81-2.82-1.27a5.24,5.24,0,0,0-3.3-.47,16.64,16.64,0,0,0-3.52,1.58l-1.84,1-.94.49c-.33.16-.66.32-.68.48s.23.55.54.8a5.12,5.12,0,0,0,1,.68,5.86,5.86,0,0,0,2.25.64,5.59,5.59,0,0,0,4.06-1.22l.26-.23.11.33a20.52,20.52,0,0,0,1.87,4.17,7,7,0,0,0,2.48,2.41A5.48,5.48,0,0,0,97.15,404Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.8,297.27c.07-5.68,1-11.34.74-17s-1.71-11.59-5.67-15.66S183,259,178.4,262.25l-1,4.84c1.82,21.9,1.57,44.15,3.4,66.05.24,2.88,2.57,5.49,3.88,8.06s3.94,4.7,6.82,4.52c3.77-.23,6.24-4.06,7.41-7.65C203.21,325.06,198.63,311,198.8,297.27Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.14,267.82a15.73,15.73,0,0,0-2.89-3.91,5.41,5.41,0,0,0-4.47-1.5,2.25,2.25,0,0,0-1.77,1.3c-.25.72.29,1.69,1.05,1.62l.16.14q2.57,2.26,5.19,4.41a4.51,4.51,0,0,0,1.45.9,1.53,1.53,0,0,0,1.59-.34C186.08,269.73,185.62,268.63,185.14,267.82Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.35,273.4c-5.66-6.92-13.26-10.91-22.2-11-5-.09-7.13,1-10.76,1.94a15.91,15.91,0,0,0-9.07,6c-2.58,3.66-4.74,7.74-5.23,12.19a74.25,74.25,0,0,0-.65,13.73,25.05,25.05,0,0,0,4.28,12.89l11.64,2c6.43.22,12.95.43,19.22-1s12.35-4.84,15.7-10.33C195.94,292.14,194,280.31,188.35,273.4Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178,273.32l-15.52-6.17-4.06.47c-9.12,0-15.42,10.09-15.48,17.48-.06,8.21.18,18.24,1.49,24.29,2.62,12.17,13,13.18,13,13.18s-.21,6.49-.29,10.57l23.77-1.71,1.19-53.94A4.32,4.32,0,0,0,178,273.32Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.67,306.54a2.58,2.58,0,0,0-.9-1.59,2.65,2.65,0,0,0-3.21-.19,3.56,3.56,0,0,0-1.35,3.33h0a3.25,3.25,0,0,0,2.31,1.34,3.09,3.09,0,0,0,.43,0,2.83,2.83,0,0,0,2-.77A2.58,2.58,0,0,0,162.67,306.54Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.05,295.49a1.57,1.57,0,0,0,1.6,1.51,1.52,1.52,0,0,0,1.55-1.51,1.59,1.59,0,0,0-1.6-1.51A1.51,1.51,0,0,0,147.05,295.49Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.71,289.21c.21.19,1.36-.75,3-.84s3,.69,3.15.47-.13-.46-.69-.82a4.32,4.32,0,0,0-2.54-.63,4.16,4.16,0,0,0-2.41.92C145.77,288.74,145.61,289.12,145.71,289.21Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.6,302.49a11.48,11.48,0,0,0-2.78-.34c-.43,0-.85-.08-.94-.38a2.28,2.28,0,0,1,.22-1.29c.35-1.07.72-2.19,1.1-3.37,1.52-4.79,2.59-8.71,2.4-8.77s-1.58,3.77-3.1,8.56l-1,3.38a2.47,2.47,0,0,0-.13,1.71,1.06,1.06,0,0,0,.74.59,2.86,2.86,0,0,0,.74.06A10.67,10.67,0,0,0,156.6,302.49Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.4,322.56a31.26,31.26,0,0,0,16.2-5.29s-3.91,8.75-16.26,8.28Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.65,303.39c-.27,0-.18,1.84-1.68,3.23s-3.47,1.3-3.47,1.56.46.33,1.28.31a4.61,4.61,0,0,0,2.91-1.19,4,4,0,0,0,1.29-2.71C162,303.82,161.78,303.38,161.65,303.39Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.29,283.28c.31.4,1.59.05,3.11.09s2.8.37,3.12,0c.14-.19-.05-.58-.6-1a4.85,4.85,0,0,0-5-.06C146.35,282.69,146.16,283.08,146.29,283.28Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.54,295.07a1.58,1.58,0,0,1-1.5,1.61,1.51,1.51,0,0,1-1.65-1.39,1.59,1.59,0,0,1,1.49-1.62A1.52,1.52,0,0,1,165.54,295.07Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.64,288.55c-.19.21-1.4-.65-3.1-.62s-2.92.91-3.11.7.1-.46.64-.87a4.29,4.29,0,0,1,2.48-.81,4.14,4.14,0,0,1,2.47.75C168.55,288.09,168.74,288.46,168.64,288.55Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.62,283.13c-.32.39-1.64,0-3.21,0s-2.91.31-3.22-.09c-.14-.19.07-.58.64-1a4.9,4.9,0,0,1,2.61-.67,4.7,4.7,0,0,1,2.57.73C167.58,282.54,167.77,282.93,167.62,283.13Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,298.11c0-.91.89-3.12,1.79-3.31,2.39-.51,6.74-.56,7.12,5.56.52,8.37-8,7.16-8,6.92S180.15,301.27,180,298.11Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,304.08s.15.1.41.19a1.43,1.43,0,0,0,1.09,0c.86-.38,1.52-1.83,1.47-3.34a4.83,4.83,0,0,0-.54-2.06,1.67,1.67,0,0,0-1.17-1.05.74.74,0,0,0-.83.45c-.1.24,0,.41-.08.42s-.19-.13-.14-.48a.9.9,0,0,1,.3-.54,1.05,1.05,0,0,1,.79-.26,2,2,0,0,1,1.6,1.2,5,5,0,0,1,.65,2.3c.05,1.69-.72,3.32-1.91,3.75a1.59,1.59,0,0,1-1.34-.14C183,304.29,183,304.1,183,304.08Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.11,294.82,180,297c-9.18-8.78-27.12-30.78-26.11-29.47A26.62,26.62,0,0,1,167,266.13c6.83,1.16,19.77,4.57,19.57,12.62S182.11,294.82,182.11,294.82Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.27,293a2.48,2.48,0,0,0-.13-.48,8.5,8.5,0,0,0-.57-1.32,12.19,12.19,0,0,0-3.5-3.93,22.74,22.74,0,0,0-7-3.39c-2.8-.91-5.95-1.62-9.05-3a41.22,41.22,0,0,1-8.27-4.63,43.1,43.1,0,0,1-5.83-5.1,45.41,45.41,0,0,1-3.37-4l-.84-1.16a2.58,2.58,0,0,0-.32-.39,2.06,2.06,0,0,0,.25.44c.17.28.42.69.77,1.2a37.22,37.22,0,0,0,3.29,4.12,40.32,40.32,0,0,0,14.16,9.92,94.67,94.67,0,0,0,9.09,2.93,23,23,0,0,1,7,3.25,12.64,12.64,0,0,1,3.53,3.77C194,292.32,194.22,293,194.27,293Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.83,294.29a4.33,4.33,0,0,0-.32-1.83,8.58,8.58,0,0,0-3.15-3.94,18.87,18.87,0,0,0-7-2.73,41.29,41.29,0,0,1-8.67-2.76,36.28,36.28,0,0,1-7.74-4.77,38.1,38.1,0,0,1-5.3-5.21,39.14,39.14,0,0,1-3-4.07l-.71-1.17a2.25,2.25,0,0,0-.27-.4,2.43,2.43,0,0,0,.2.44l.64,1.22a34,34,0,0,0,2.87,4.17,36,36,0,0,0,13.09,10.18,40.54,40.54,0,0,0,8.76,2.75,19,19,0,0,1,6.9,2.6,8.62,8.62,0,0,1,3.16,3.75A10.07,10.07,0,0,1,191.83,294.29Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.83,309c0-.05.71-.14,1.95-.47a11.79,11.79,0,0,0,4.68-2.62,16.63,16.63,0,0,0,4.35-6.65,29.47,29.47,0,0,0,1.82-9.65,24.84,24.84,0,0,0-.41-5.08,23.48,23.48,0,0,0-5.72-11.28,38.87,38.87,0,0,0-5.62-4.9,2.29,2.29,0,0,1,.47.25c.29.18.73.42,1.26.8a25.48,25.48,0,0,1,4.18,3.59,23.7,23.7,0,0,1,4.51,6.81,24.09,24.09,0,0,1,1.45,4.63,24.59,24.59,0,0,1,.43,5.19,29.17,29.17,0,0,1-1.89,9.82,16.89,16.89,0,0,1-4.57,6.77,11.63,11.63,0,0,1-4.88,2.53,12.08,12.08,0,0,1-1.48.24A2,2,0,0,1,181.83,309Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.48,411.91,143,419.1c-18.58,5.26-38.16,6.8-58.63,5l74.47,34.74,29.89.46s9.11,0,10.7-7.94,3.36-32.12,3.36-32.12S196.87,414.12,192.48,411.91Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.33,432.74a71.7,71.7,0,0,1,.88,15,14.92,14.92,0,0,0,3.67-12.5c-.44-2.44-1.46-5.13-.18-7.26.86-1.43,3.13-3.07,2.8-4.7,0,0-2,0-3.79-.07-1.45-.06-4.46-.15-4.46-.15a16,16,0,0,1,.8,9.83",
    transform: "translate(-13.61 -26.94)"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "143.6 304.15 167.64 301.56 172.04 305.56 154.88 315.65 147.31 319.58 139.83 317.31 137.46 312.85 143.6 304.15",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.8,360.37s7.54-14.46,9.4-17.62c3.18-5.39,9.12-8.44,9.12-8.44l13.89-3.21s-1.44,7,7.2,7.44c11,.61,17.83-9.93,17.83-9.93s12.54,1.29,16,2.74,13.26,5.56,14.7,18.59l3.36,21.26-26.5,2,.37,28.32-11.27,9.21s-32.33,11.13-34.4,11.86c-1,.35-.73-13.39-3-25.16l-4.37-10.6A41.07,41.07,0,0,1,134,373.53c-.17-3-.09-5.3-.09-5.3S127.11,365.9,124.8,360.37Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.68,411.49l44.43-13.33-.31-24.94,22.62-1.72s-1.8,12.92-2.07,19.54c-.38,9.53-5,22.85-8,25.67s-57.82,5.9-57.82,5.9Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.48,419.33a1.75,1.75,0,0,0,2.19.73c1-.4.73-2.42.73-2.42l4.73-1.16s6.53,3.54,9,6,7.9-.11,7.9-.11L146.16,412l-9.43-7.28s.58.43-.15-1-3.45-.66-3.45-.66c-.48-.71-2.31-.83-2.31-.83l-7.67,1.49a5.29,5.29,0,0,0-3.68,2.74l-2.87,5.42s-1.44,3.86-1.09,4.71a1.56,1.56,0,0,0,1.88.88s.57,2.42,1.22,2.45a5.15,5.15,0,0,0,1.87-.61Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.37,410.73c0,.08-1,.06-2.68.26a22.75,22.75,0,0,0-9.37,3.32c-.89.59-1.83,1.1-2.08,1.81a.94.94,0,0,0,.16.91,1.26,1.26,0,0,0,.62.45c.42.14.67,0,.69,0s-.23.23-.74.14a1.43,1.43,0,0,1-.78-.46,1.22,1.22,0,0,1-.28-1.2,2.48,2.48,0,0,1,.88-1.16c.4-.31.82-.62,1.29-.93a20.39,20.39,0,0,1,9.57-3.27A8.46,8.46,0,0,1,136.37,410.73Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.3,415.62c0,.14-3.16.26-7,.78s-6.92,1.24-7,1.1a7.57,7.57,0,0,1,2-.65,43.53,43.53,0,0,1,4.92-.94,44,44,0,0,1,5-.39A7.64,7.64,0,0,1,137.3,415.62Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.51,419.13a4,4,0,0,1-.16-.81,20,20,0,0,1-.18-2.27,9.93,9.93,0,0,1,.1-1.58,4.86,4.86,0,0,1,.62-1.74,10.73,10.73,0,0,1,2.67-3.2,14.69,14.69,0,0,1,3.56-2.15,13.46,13.46,0,0,1,3.3-.77c1-.11,1.72-.15,2.26-.17a2.85,2.85,0,0,1,.83,0,25.51,25.51,0,0,1-3,.5,14.49,14.49,0,0,0-3.18.84,14.94,14.94,0,0,0-3.42,2.12,10.72,10.72,0,0,0-2.58,3,5.92,5.92,0,0,0-.77,3.11C120.48,417.94,120.62,419.13,120.51,419.13Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.6,404.24c0,.08-1.15.2-3,.55s-4.6.76-6,3.34a26.52,26.52,0,0,0-3.43,6.37,15.63,15.63,0,0,0-.51,2.95,1.94,1.94,0,0,1-.11-.82,7.6,7.6,0,0,1,.28-2.23,23,23,0,0,1,3.36-6.55,8.69,8.69,0,0,1,1.38-1.63,5.39,5.39,0,0,1,1.76-1,16.53,16.53,0,0,1,3.23-.77A12.24,12.24,0,0,1,130.6,404.24Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.27,421a3.08,3.08,0,0,1-.49-.32l-1.37-.94a53.74,53.74,0,0,0-5.36-3.1h.11l-4.72,1.19.15-.22a5.17,5.17,0,0,1,0,1.18,2.2,2.2,0,0,1-.45,1.19,1.21,1.21,0,0,1-.61.34,1.88,1.88,0,0,1-.67.1,2,2,0,0,1-1.25-.57,2,2,0,0,1-.23-.27l0-.07,0,0v0h0l.29.08h0l-.15.07a5.46,5.46,0,0,1-.6.27,6,6,0,0,1-.64.22c-.11,0-.23,0-.35.06a.75.75,0,0,1-.45-.05,1.38,1.38,0,0,1-.52-.6,5.24,5.24,0,0,1-.29-.64,9.77,9.77,0,0,1-.41-1.33l.29.17a1.81,1.81,0,0,1-1.83-.47,1.44,1.44,0,0,1-.4-.93,4,4,0,0,1,.1-.94,25.66,25.66,0,0,1,1.05-3.55h0v0l1.53-2.89,1-1.84a10,10,0,0,1,1.08-1.79,5.28,5.28,0,0,1,1.65-1.29,6.77,6.77,0,0,1,1.94-.56l7.22-1.38h.06a7,7,0,0,1,1.31.24,2.19,2.19,0,0,1,1.17.69l-.28-.06a2.67,2.67,0,0,1,2.5,0,3.15,3.15,0,0,1,1.38,1.86l-.07-.1,6.5,5,1.75,1.38a3.77,3.77,0,0,1,.59.51,4.1,4.1,0,0,1-.65-.43l-1.82-1.3-6.59-4.86-.05,0,0-.06a2.81,2.81,0,0,0-1.21-1.62,2.33,2.33,0,0,0-2.1.07l-.17.09-.11-.15a1.89,1.89,0,0,0-1-.52,7.84,7.84,0,0,0-1.21-.21h.06l-7.22,1.42a6.49,6.49,0,0,0-1.82.53,4.65,4.65,0,0,0-1.48,1.17,8.61,8.61,0,0,0-1,1.7c-.32.61-.65,1.22-1,1.84-.53,1-1,2-1.53,2.89v0a24.84,24.84,0,0,0-1,3.47,4,4,0,0,0-.09.83,1,1,0,0,0,.28.64,1.33,1.33,0,0,0,1.34.33l.24-.05,0,.23c.11.43.24.86.39,1.27a2.47,2.47,0,0,0,.58,1,.6.6,0,0,0,.2,0l.29,0c.2-.05.39-.12.59-.19l.57-.25.14-.07h0c-.26-.07.36.1.29.09h0v0l0,.06.18.21a1.52,1.52,0,0,0,1,.45,1.17,1.17,0,0,0,.52-.07.76.76,0,0,0,.42-.21,3,3,0,0,0,.37-2v-.18l.16,0,4.74-1.12h.06l0,0a46.22,46.22,0,0,1,5.31,3.26c.59.42,1,.77,1.33,1A3.17,3.17,0,0,1,135.27,421Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.18,427.42s-31.36-9.85-41.2-13c-17-5.5-28.06.06-31.56,6.12-4.54,7.87,6.35,23.22,10.55,26.75,12.43,10.45,33.74,11.86,33.74,11.86h0l76.62-.15L138,428.63Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.86,441.64a76.29,76.29,0,0,1-37.61-5.12A48.83,48.83,0,0,0,73,434.19a18.29,18.29,0,0,0-6.47-.46,6.46,6.46,0,0,0-4.57,2.07c-1.52,2-.74,4.88.11,7.27,1,2.79,2,5.65,4,7.89,2.27,2.62,5.57,4.11,8.88,5.15,6.47,2,13.3,2.63,20.08,2.9l23.28-1.28Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.91,434.2a2.05,2.05,0,0,1,.35.63,9.59,9.59,0,0,1,.62,1.85,12,12,0,0,1-3.8,11.82,10.84,10.84,0,0,1-1.58,1.15c-.41.23-.64.33-.66.3s.84-.58,2-1.71a13,13,0,0,0,3.3-5.27,13.1,13.1,0,0,0,.39-6.21C72.25,435.16,71.82,434.23,71.91,434.2Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.19,425.5c-1.82-5.16-2.12-12.74-13.35-16.38s-19.71,3.34-25.48,5.76-37.3,19.72-37.3,19.72-5.94,10.59-4.25,15.27,9.37,9.3,9.37,9.3h35.27c9.1,0,26-.31,26-.31a103.68,103.68,0,0,0,6.07-11.52l.3-1.52C188.85,444.61,194,430.65,192.19,425.5Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.65,452.29a1.12,1.12,0,0,1-.26.48,6.36,6.36,0,0,1-1.16,1.05,30.29,30.29,0,0,1-5,2.79,32.48,32.48,0,0,1-3.68,1.45,27.24,27.24,0,0,1-4.45,1,85.57,85.57,0,0,1-10.36.4c-7.33.12-14,.4-18.8.34-2.41,0-4.36-.11-5.7-.25a14.3,14.3,0,0,1-1.54-.22,2.64,2.64,0,0,1-.53-.12c0-.05.74.08,2.08.15s3.29.12,5.69.1c4.81,0,11.45-.37,18.8-.49a91,91,0,0,0,10.3-.36,27.67,27.67,0,0,0,4.39-.9,39.28,39.28,0,0,0,8.68-4,7.13,7.13,0,0,0,1.19-1C172.56,452.46,172.62,452.28,172.65,452.29Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.18,459.17a5.28,5.28,0,0,1-.47-.25c-.3-.18-.74-.45-1.31-.82a31.72,31.72,0,0,1-4.64-3.69,14.6,14.6,0,0,1-2.62-3.38,7.83,7.83,0,0,1-.52-5,42.34,42.34,0,0,1,4.27-11.5l0-.05,0,0c5.78-3.18,12.4-6.79,19.65-10.68,3.62-1.94,7.39-3.95,11.31-6,2-1,4-2,6-3s4.05-2,6.12-3.08a34.6,34.6,0,0,1,9.11-3.43,22.4,22.4,0,0,1,4.75-.43,20.93,20.93,0,0,1,4.62.66,22.08,22.08,0,0,1,8.08,3.86,16,16,0,0,1,2.93,3.18,18.22,18.22,0,0,1,1.9,3.73c.49,1.28.85,2.57,1.21,3.83a29.9,29.9,0,0,1,1,3.74,24.58,24.58,0,0,1-.6,7.21c-.46,2.25-1,4.35-1.57,6.3-.28,1-.56,1.93-.82,2.84s-.56,1.81-.7,2.61v0c-.12.57-.21,1-.31,1.51h0a37.19,37.19,0,0,1-4.05,8.79,15.7,15.7,0,0,1-2.15,2.7l.13-.18.42-.51a22.9,22.9,0,0,0,1.48-2.09,38.16,38.16,0,0,0,3.91-8.78h0c.58-.48.47-.95.3-1.52v0a23.7,23.7,0,0,1,.68-2.7l.81-2.84c.54-1.95,1.08-4,1.52-6.28a24.38,24.38,0,0,0,.56-7.09,34,34,0,0,0-1-3.68c-.37-1.25-.73-2.53-1.22-3.79a18.27,18.27,0,0,0-1.85-3.63,15.66,15.66,0,0,0-2.86-3.07,21.53,21.53,0,0,0-7.91-3.76,20.44,20.44,0,0,0-4.51-.64,21.44,21.44,0,0,0-4.64.43,33.67,33.67,0,0,0-9,3.39c-2,1-4,2.2-6.15,3.09s-4,1.95-6,2.95c-3.91,2-7.69,4-11.31,6l-19.68,10.61.07-.08a42.17,42.17,0,0,0-4.29,11.37,7.49,7.49,0,0,0,.45,4.85,14.24,14.24,0,0,0,2.54,3.35,34,34,0,0,0,4.55,3.75l1.28.86C121,459.06,121.18,459.17,121.18,459.17Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.58,446.08s10.51,1.26,9.58,6.4-4.37,6.87-4.37,6.87l-28.56.06S172.28,458.23,178.58,446.08Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.6,443.58a3.53,3.53,0,0,1-.32,1.46,11,11,0,0,1-1.7,3.19,8.62,8.62,0,0,1-4,3.08,23.42,23.42,0,0,0,3.63-3.38A29.33,29.33,0,0,0,179.6,443.58Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,445.6a6.87,6.87,0,0,1-1,3.66,8,8,0,0,1-2.29,3c-.11-.09.92-1.42,1.85-3.25S175.82,445.58,176,445.6Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.36,457.92c-.08,0,.6-1.34,1.42-3.55a37.82,37.82,0,0,0,2.07-18.09c-.31-2.33-.67-3.76-.59-3.78a3.7,3.7,0,0,1,.33,1,25.12,25.12,0,0,1,.6,2.75,33.78,33.78,0,0,1-2.09,18.26,23,23,0,0,1-1.2,2.55A4.5,4.5,0,0,1,189.36,457.92Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.41,443.31c-.07-.69-.34-1.51-1-1.65s-1.4.79-1.73,1.57C177,451.6,165.11,458.13,156,459a83.33,83.33,0,0,0,13.19-1.08,20,20,0,0,0,10.06-4.6A12.17,12.17,0,0,0,183.41,443.31Z",
    transform: "translate(-13.61 -26.94)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M113.83,431.92a30.37,30.37,0,0,1-5-1.93,29.57,29.57,0,0,1-4.86-2.37,31.1,31.1,0,0,1,5.06,1.92A28.68,28.68,0,0,1,113.83,431.92Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124,427.5q-20.4-3.9-40.95-6.93l-10.2,3.23c2.86,5.31,8.51,8.7,14.38,10.1s12,1.07,18,.52c6.62-.61,13.42-1.54,19.18-4.86.44-.25.94-.63.88-1.14S124.59,427.61,124,427.5Z",
    transform: "translate(-13.61 -26.94)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.06,387l17.13,37.9a4.44,4.44,0,0,0,4,2.61l50,.65,6.3-3.39-9.87-.72-15.36-36.86a3.17,3.17,0,0,0-2.9-1.95l-47.89-.37A1.51,1.51,0,0,0,57.06,387Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.06,387a1.16,1.16,0,0,1-.15-.46,1.52,1.52,0,0,1,.47-1.31,1.58,1.58,0,0,1,1-.42h4.39l20.05.07,13.94.07,7.79.05,2,0a3.39,3.39,0,0,1,2,.84,4.24,4.24,0,0,1,1.15,1.84l.82,2,14.32,34.29-.24-.17,9.53.7.34,0,1,.07-.85.46-6.3,3.39-.06,0h-.08l-37.9-.52-8.46-.12c-1.38,0-2.7,0-4.07-.09a4.67,4.67,0,0,1-3.39-2.09c-2.23-4.69-4.09-9-5.9-13-3.54-7.92-6.39-14.31-8.38-18.74-1-2.2-1.72-3.91-2.24-5.09q-.36-.86-.57-1.32c-.13-.3-.18-.46-.18-.46a4.14,4.14,0,0,1,.23.44l.62,1.3c.54,1.17,1.32,2.87,2.33,5l8.54,18.68c1.81,3.93,3.75,8.35,5.93,12.91a4.2,4.2,0,0,0,3.06,1.88c1.28.06,2.67,0,4,.07l8.45.1,37.91.46-.14,0,6.3-3.39.11.53-.33,0-9.53-.7h-.17l-.07-.16c-5.09-12.25-9.91-23.83-14.27-34.31l-.81-2a3.91,3.91,0,0,0-1-1.67,3,3,0,0,0-1.72-.73l-2,0-7.79-.07-13.93-.14L62.73,385,59.6,385l-1.25,0a1.4,1.4,0,0,0-.9.37,1.48,1.48,0,0,0-.49,1.22A3.75,3.75,0,0,0,57.06,387Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.12,428.09a2,2,0,0,1-.23-.42l-.57-1.22c-.51-1.14-1.18-2.68-2-4.54-1.67-3.85-3.94-9.17-6.38-15.09s-4.6-11.29-6.09-15.2c-.75-2-1.34-3.55-1.72-4.66-.18-.51-.32-.94-.44-1.28a2.27,2.27,0,0,1-.12-.46,1.77,1.77,0,0,1,.22.43l.52,1.24c.46,1.16,1.1,2.71,1.86,4.6,1.62,3.94,3.81,9.26,6.22,15.15s4.63,11.19,6.25,15.13c.77,1.89,1.4,3.45,1.86,4.6l.49,1.26A1.4,1.4,0,0,1,123.12,428.09Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.12,405.37a2.46,2.46,0,1,1-2.45-2.45A2.45,2.45,0,0,1,92.12,405.37Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.77,344.4c.08,0-.64,1.39-1.65,3.63A62.47,62.47,0,0,0,134,366.47c-.3,2.45-.38,4-.47,4a4.15,4.15,0,0,1,0-1.08c0-.69,0-1.69.14-2.93a52.43,52.43,0,0,1,5.18-18.56c.55-1.11,1-2,1.39-2.58A4.4,4.4,0,0,1,140.77,344.4Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.3,371.2a2.08,2.08,0,0,1-.55.09l-1.59.15-5.94.5-20.31,1.53-.26,0,0-.26c-.17-2.7-.35-5.55-.53-8.47-.29-5.1-.54-10-.62-14.39A20.38,20.38,0,0,1,189.09,339a14,14,0,0,1,5.69-5.47,11.05,11.05,0,0,1,2-.79,5.64,5.64,0,0,1,.73-.18c0,.08-1,.29-2.65,1.15a14.28,14.28,0,0,0-5.47,5.48A20.31,20.31,0,0,0,187,350.36c.11,4.41.37,9.27.66,14.37.18,2.92.35,5.77.52,8.47l-.28-.25,20.33-1.34,6-.34,1.59-.07A2.64,2.64,0,0,1,216.3,371.2Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.48,388.52a2.87,2.87,0,0,1-.89-.32,8.42,8.42,0,0,1-1-.5,12.58,12.58,0,0,1-1.25-.77,18.59,18.59,0,0,1-2.93-2.48,21.44,21.44,0,0,1-2.8-3.78,21,21,0,0,1-1.81-4.34,18.53,18.53,0,0,1-.64-3.78c0-.55,0-1,0-1.47a8.2,8.2,0,0,1,.08-1.11,2.93,2.93,0,0,1,.18-.93c.1,0-.07,1.34.14,3.48a20.43,20.43,0,0,0,.73,3.67,22.81,22.81,0,0,0,1.81,4.22,21.53,21.53,0,0,0,2.7,3.7,19.72,19.72,0,0,0,2.78,2.51C165.28,387.89,166.52,388.43,166.48,388.52Z",
    transform: "translate(-13.61 -26.94)",
    fill: "#263238"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDc11);
export default __webpack_public_path__ + "static/media/dc1_1.d631a5f00f2f67b60695a2fa684c8240.svg";
export { ForwardRef as ReactComponent };